import moment from 'moment'
import mixins from '@/mixins'
const addCommasDecimal =  mixins.methods.addCommasDecimal
const addCommas =  mixins.methods.addCommas

export default {
    chart:{
      backgroundColor:'transparent',
      height:350,
      zoomType:'x',
      resetZoomButton: {
        theme: {
            fill: 'white',
            stroke: '#41739D',
            style:{
              color:'#41739D',
            },
            r: 5,
            states: {
                hover: {
                    fill: '#41739D',
                    style: {
                        color: 'white'
                    }
                }
            }
        }
      }
    },
    title: {
        text: ''
    },
    xAxis: {
      type: 'datetime',
      lineColor: '#DDD9F9',
      tickColor: '#DDD9F9',
      labels: {
        style:{
          color: '#667091',
          fontSize:'12px'
        }
      },
      events: {}
    },
    yAxis: {
      labels: {
        style:{
          color: '#667091',
          fontSize:'12px'
        },
        formatter(){
          return addCommas(this.value);
        },
      },
      gridLineColor:'#DDD9F9',
      opposite:true,
      title: null
    },
    tooltip:{
      borderColor:'#DDD9F9',
      backgroundColor:'rgba(250,250,255,0.8)',
      style:{
        color:'#667091'
      },
      formatter(){
        return `<div>
          <strong>${moment(this.x).utc().format('dddd, MMM DD, HH:mm')}</strong><br>
          Open: ${addCommasDecimal(this.point.open)}<br>
          High: ${addCommasDecimal(this.point.high)}<br>
          Low: ${addCommasDecimal(this.point.low)}<br>
          Close: ${addCommasDecimal(this.point.close)}
        </div>`;
      }
    },
    plotOptions:{
      candlestick:{
        color:'#ef5350',
        lineColor:'#ef5350',
        upColor:'#26a69a',
        upLineColor:'#26a69a',
      },
    },
    series: [{
          type: 'candlestick',
          data: [],
          showInLegend: false
      }],
}